import type * as THREE from "three";

/** Добавки поверх позы клипа, 0..1 каждая (кости поворачиваются после клипа, клип не меняется). */
export interface OverlayWeights {
  /** «Держит удар»: пятки приподняты, корпус сжат (блок, отброс). */
  readonly brace: number;
  /** Реакция на попадание: голова и корпус дёргаются назад и гаснут. */
  readonly flinch: number;
  /** Приземление: колени гасят удар о пол, таз проседает (render/secondaryMotion.ts). */
  readonly land: number;
  /** Отдача у бьющего: удар встретил тело или блок — корпус и голова на миг назад. */
  readonly recoil: number;
}

/** Насколько проседает таз на полном приземлении, пиксели мира. */
const LAND_DROP = 4;

/**
 * Наложить добавки на скелет модели Mixamo. Ось x кости — наклон вперёд-назад: у корпуса «+» — вперёд, у бедра «+» —
 * колено вперёд, у голени «−» — сгиб колена, у стопы «+» — носок вниз.
 */
export function applyOverlay(root: THREE.Object3D, weights: OverlayWeights): void {
  const turn = (name: string, angle: number): void => {
    const node = root.getObjectByName(name);
    if (node) node.rotation.x += angle;
  };
  const { brace, flinch, land, recoil } = weights;
  if (brace > 0) {
    // пятки вверх, вес на носках; корпус вперёд, голова вниз — держит удар
    turn("mixamorigLeftFoot", 0.55 * brace);
    turn("mixamorigRightFoot", 0.55 * brace);
    turn("mixamorigLeftToeBase", -0.45 * brace);
    turn("mixamorigRightToeBase", -0.45 * brace);
    turn("mixamorigSpine1", 0.22 * brace);
    turn("mixamorigHead", 0.18 * brace);
  }
  if (flinch > 0) {
    turn("mixamorigHead", -0.6 * flinch);
    turn("mixamorigSpine2", -0.28 * flinch);
  }
  if (land > 0) {
    // колени гасят удар: бедро вперёд, голень назад вдвое, стопа обратно — подошва на полу; таз ниже, корпус вперёд
    for (const leg of ["Left", "Right"]) {
      turn(`mixamorig${leg}UpLeg`, 0.28 * land);
      turn(`mixamorig${leg}Leg`, -0.56 * land);
      turn(`mixamorig${leg}Foot`, 0.28 * land);
    }
    turn("mixamorigSpine", 0.12 * land);
    turn("mixamorigHead", -0.08 * land);
    root.position.y -= LAND_DROP * land;
  }
  if (recoil > 0) {
    turn("mixamorigSpine2", -0.16 * recoil);
    turn("mixamorigHead", -0.12 * recoil);
  }
}
